(function () {
    const YOUTUBEICON = '<svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%">' +
        '<path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,' +
        '.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,' +
        '10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,' +
        '4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#212121" fill-opacity="0.8">' +
        '</path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg>';
    const IFRAMES = {
        'videopress': {
            openTag: (videoId) => '<div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 56.2493%;">' +
                '<iframe class="externalvideo" src="https://videopress.com/embed/' + videoId +
                '" style="border: 0; top: 0; left: 0; width: 100%; height: 100%; position: absolute;" allowfullscreen scrolling="no">',
            closeTag: () => '</iframe></div>'
        },
        'vimeo': {
            openTag: (videoId) => '<div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 56.2493%;">' +
                '<iframe class="externalvideo" src="https://player.vimeo.com/video/' + videoId +
                '?byline=0&badge=0&portrait=0&title=0" style="border: 0; top: 0; left: 0; width: 100%; '+
                'height: 100%; position: absolute;" allowfullscreen scrolling="no">',
            closeTag: () => '</iframe></div>'
        },
        'vine': {
            openTag: (videoId) => '<div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 100%;">' +
                '<iframe class="externalvideo" src="https://vine.co/v/' + videoId +
                '/embed/simple" style="border: 0; top: 0; left: 0; width: 100%; height: 100%; position: absolute;" allowfullscreen>',
            closeTag: () => '</iframe></div>'
        },
        'youtube': {
            openTag: (videoId) => '<div class="oplwidget-preview--youtube imgcontainer" allowfullscreen>' +
                '<div class="oplwidget-preview--youtube-icon"><?xml version="1.0" encoding="UTF-8" standalone="no"?>' + YOUTUBEICON +
                '</div><img class="oplwidget-preview--youtube-preview" src="https://img.youtube.com/vi/' + videoId +
                '/mqdefault.jpg" data-src="https://www.youtube.com/embed/' + videoId +
                '?rel=0&showinfo=0&controls=2&autoplay=1" data-videoid=' + videoId + '>',
            closeTag: () => '</div>'
        }
    };

    function iframify(md) {
        const originalLinkOpenRenderer = md.renderer.rules.link_open;
        const originalLinkCloseRenderer = md.renderer.rules.link_close;
        const originalTextRenderer = md.renderer.rules.text;

        md.renderer.rules.link_open = (tokens, idx, options, env) => {
            const href = tokens[idx].href;
            const videoContext = parseVideoId(href);

            if (videoContext) {
                const iframe = IFRAMES[videoContext.service];

                if (iframe) {
                    env.iframe_service = videoContext.service;
                    return iframe.openTag(videoContext.id);
                }
            }

            return originalLinkOpenRenderer(tokens, idx, options, env);
        };

        md.renderer.rules.text = (tokens, idx, options, env) => {
            if(tokens[idx].type === 'text' && idx > 0 && tokens[idx-1].type === 'link_open') {
                const href = tokens[idx-1].href;
                const videoContext = parseVideoId(href);
                if (videoContext) {
                    return '';
                }
            }
            return originalTextRenderer(tokens, idx, options, env);
        };

        md.renderer.rules.link_close = (tokens, idx, options, env) => {
            if (env.iframe_service) {
                const result = IFRAMES[env.iframe_service].closeTag();
                env.iframe_service = null;
                return result;
            }

            return originalLinkCloseRenderer(tokens, idx, options, env);
        };
    }

    function parseVideoId(str) {
        // remove surrounding whitespaces or linefeeds
        str = str.trim();

        // remove the '-nocookie' flag from youtube urls
        str = str.replace('-nocookie', '');

        // remove any leading `www.`
        str = str.replace('/www.', '/');

        // Try to handle google redirection uri
        if (/\/\/google/.test(str)) {
            // Find the redirection uri
            const matches = str.match(/url=([^&]+)&/);

            // Decode the found uri and replace current url string - continue with final link
            if (matches) {
                // Javascript can get encoded URI
                str = decodeURIComponent(matches[1]);
            }
        }

        if (/youtube|youtu\.be|i.ytimg\./.test(str)) {
            const id = youtube(str);
            if(id === undefined)
                return null;
            return {
                id: id,
                service: 'youtube'
            };
        } else if (/vimeo/.test(str)) {
            const id = vimeo(str);
            if(id === undefined)
                return null;
            return {
                id: id,
                service: 'vimeo'
            };
        } else if (/vine/.test(str)) {
            const id = vine(str);
            if(id === undefined)
                return null;
            return {
                id: id,
                service: 'vine'
            };
        } else if (/videopress/.test(str)) {
            const id = videopress(str);
            if(id === undefined)
                return null;
            return {
                id: id,
                service: 'videopress'
            };
        } else {
            return null;
        }
    }

    /**
     * Get the vimeo id.
     * @param {string} str - the url from which you want to extract the id
     * @returns {string|undefined}
     */
    function vimeo(str) {
        if (str.indexOf('#') > -1) {
            str = str.split('#')[0];
        }
        if (str.indexOf('?') > -1) {
            str = str.split('?')[0];
        }

        let id;

        if (/https?:\/\/vimeo\.com\/[0-9]+$|https?:\/\/player\.vimeo\.com\/video\/[0-9]+$|https?:\/\/vimeo\.com\/channels|groups|album/igm.test(str)) {
            const arr = str.split('/');
            if (arr && arr.length) {
                id = arr.pop();
            }
        }

        return id;
    }

    /**
     * Get the vine id.
     * @param {string} str - the url from which you want to extract the id
     * @returns {string|undefined}
     */
    function vine(str) {
        const regex = /https:\/\/vine\.co\/v\/([a-zA-Z0-9]*)\/?/;
        const matches = regex.exec(str);
        return matches && matches[1];
    }

    /**
     * Get the Youtube Video id.
     * @param {string} str - the url from which you want to extract the id
     * @returns {string|undefined}
     */
    function youtube(str) {
        // shortcode
        const shortcode = /youtube:\/\/|https?:\/\/youtu\.be\//g;

        if (shortcode.test(str)) {
            const shortcodeid = str.split(shortcode)[1];
            return stripParameters(shortcodeid);
        }

        // /v/ or /vi/
        const inlinev = /\/v\/|\/vi\//g;

        if (inlinev.test(str)) {
            const inlineid = str.split(inlinev)[1];
            return stripParameters(inlineid);
        }

        // v= or vi=
        const parameterv = /v=|vi=/g;

        if (parameterv.test(str)) {
            const arr = str.split(parameterv);
            return arr[1].split('&')[0];
        }

        // v= or vi=
        const parameterwebp = /\/an_webp\//g;

        if (parameterwebp.test(str)) {
            const webp = str.split(parameterwebp)[1];
            return stripParameters(webp);
        }

        // embed
        const embedreg = /\/embed\//g;

        if (embedreg.test(str)) {
            const embedid = str.split(embedreg)[1];
            return stripParameters(embedid);
        }

        // user
        const userreg = /\/user\//g;

        if (userreg.test(str)) {
            const elements = str.split('/');
            return stripParameters(elements.pop());
        }

        // attribution_link
        const attrreg = /\/attribution_link\?.*v%3D([^%&]*)(%26|&|$)/;

        if (attrreg.test(str)) {
            return str.match(attrreg)[1];
        }
    }

    /**
     * Get the VideoPress id.
     * @param {string} str - the url from which you want to extract the id
     * @returns {string|undefined}
     */
    function videopress(str) {
        let idRegex;

        if (str.indexOf('embed') > -1) {
            idRegex = /embed\/(\w{8})/;
            return str.match(idRegex)[1];
        }

        idRegex = /\/v\/(\w{8})/;
        return str.match(idRegex)[1];
    }

    /**
     * Strip away any parameters following `?` or `/`
     * @param str
     * @returns {*}
     */
    function stripParameters(str) {
        // Split parameters or split folder separator
        if (str.indexOf('?') > -1) {
            return str.split('?')[0];
        } else if (str.indexOf('/') > -1) {
            return str.split('/')[0];
        }
        return str;
    }


    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = iframify;
        }
        exports.iframify = iframify;
    }
    else {
        window.iframify = iframify;
    }
})();
